module.exports = __webpack_public_path__ + "static/img/wechat_self.58f0cfa1.png";